<template>
  <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4" align="left">{{ message }}
        <v-toolbar dark color="yellow" dense flat>
          <v-toolbar-title class="black--text">Dog information</v-toolbar-title>
        </v-toolbar>

        <table v-if="dog != null">
          <tr><td width="160px">K9 ACSW reg#</td><td>{{dog.kNbr}}</td></tr>
          <tr><td>Callname</td><td>{{dog.callName}}</td></tr>
          <tr><td>Gender</td><td>{{dog.gender}}</td></tr>
          <tr><td>Breed</td><td>{{dog.breed}}</td></tr>
          <tr><td>Age</td><td>{{ dogAge}} years</td></tr>
          <tr><td>Rescue?</td><td>{{ yesno(dog.rescue) }}</td></tr>
          <tr><td>Dog reactive?</td><td>{{ yesno(dog.dogReactive) }}</td></tr>
          <tr><td>Human reactive?</td><td>{{ yesno(dog.humanReactive) }}</td></tr>
          <tr><td>Want reactive parking?</td><td>{{ yesno(dog.reactiveParking) }}</td></tr>
        </table>
        <v-toolbar dark color="yellow" dense flat>
          <v-toolbar-title class="black--text">Owner information</v-toolbar-title>
        </v-toolbar>
        <table v-if="dogowner != null">
          <tr><td width="160px">ACSW member#</td><td>{{dogowner.mNbr}}</td></tr>
          <tr><td>Name</td><td>{{dogowner.fullName}}</td></tr>
        </table>
        <v-toolbar dark color="yellow" dense flat>
          <v-toolbar-title class="black--text">Handler information</v-toolbar-title>
        </v-toolbar>
        <table v-if="doghandler != null">
          <tr><td width="160px">ACSW member#</td><td>{{doghandler.mNbr}}</td></tr>
          <tr><td>Name</td><td>{{doghandler.fullName}}</td></tr>
          <tr><td>First aid qualified</td><td>{{yesno(doghandler.firstAidQual)}}</td></tr>
        </table>

      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="agree">Yes, I confirm the information above</v-btn>
      </v-card-actions>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="cancel">No, the information is inaccurate</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    k9: null,
    options: {
      color: 'primary',
      width: 390,
      zIndex: 200
    }
  }),
  props: {
    dogowner: {
      type: Object,
      default:
          null
    },
    doghandler: {
      type: Object,
      default:
          null
    },
    dog: {
      type: Object,
      default:
          null
    },
  },
  methods: {
    yesno(tf) {
      if(tf) return 'Yes'
      return 'No'
    },
    open(title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    }
  },
  computed: {
    dogAge () {
      const dogDays = this.$daySpan(new Date(), new Date(this.dog.dob))
      const dogYears = Math.floor(dogDays/365)
      return dogYears
    }

  }
}
</script>